/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Notes_Save_FailedInputs */

const en_task_notes_save_failed = /** @type {(inputs: Task_Notes_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not save`)
};

const pt_br2_task_notes_save_failed = /** @type {(inputs: Task_Notes_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível salvar`)
};

/**
* | output |
* | --- |
* | "Could not save" |
*
* @param {Task_Notes_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_notes_save_failed = /** @type {((inputs?: Task_Notes_Save_FailedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Notes_Save_FailedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_notes_save_failed(inputs)
	return pt_br2_task_notes_save_failed(inputs)
});